module.exports = __webpack_public_path__ + "img/Metastasis-ASHN_GSE227469.9ccec862.png";